import { render, staticRenderFns } from "./EditCurrency.vue?vue&type=template&id=fc5be28e&"
import script from "./EditCurrency.vue?vue&type=script&lang=js&"
export * from "./EditCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports